import React from 'react';

import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';

const EnrolledAuditBox = () => {
  const theme = useTheme();
  const { t } = useTranslation('store_course');
  return (
    <Box sx={{ display: 'flex', gap: '3px', alignItems: 'center', minHeight: { xs: '34px', md: '43px' } }}>
      <FontAwesomeIcon style={{ padding: '4px', fontSize: '22px' }} icon="fa-light fa-circle-check" />
      <Typography sx={{ color: theme.palette.textOnPrimary.primary }} variant="button_deprecated">
        {t('course_detail.header_banner.purchase.already.text')}
      </Typography>
    </Box>
  );
};

export default EnrolledAuditBox;
